module.exports = __webpack_public_path__ + "static/media/plan-ex.bdb7504d.png";